import React, { useContext } from 'react';

import {ModalContext} from './modal-provider';

export interface IModalCloserProps {
    children: React.ReactNode;
    onClose?: () => void;
}

export const ModalCloser = (props: IModalCloserProps): JSX.Element => {
    const { close } = useContext(ModalContext);

    const enhanceItem = (child: React.ReactNode) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                onClick: (event: React.MouseEvent<HTMLElement>) => {
                    event.preventDefault();

                    if (close) {
                        if (props.onClose) {
                            props.onClose();
                        }
                        close(event, child.props.onClick);
                    }
                },
            } as React.HTMLAttributes<HTMLElement>);
        }
    };

    const children = React.Children.map(props.children, enhanceItem.bind(this));
    const child = children && children.length ? children[0] : null;

    return child ? <>{React.Children.only(child)}</> : <React.Fragment />;
};
